<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EKkFw8/images/9781455594726_cover_epub.jpg?1733151160865" alt="This image is the cover for the book Last True Hero, Battle Scars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last True Hero, Battle Scars
      </h1>
      <p class="bookDescription body article font2">
        <p>"With her usual charm and engaging storytelling Diana Gardin has once again proved why she's my new go-to author." -- #1 <i>New York Times</i> bestselling author Rachel Van Dyken <br/><br/> For seven years he's fought for his country. Now he'll fight for her.<br/><br/> Army Ranger Dare Conners has been through hell. He's left combat behind, yet the memories that refuse to fade are proving just as dangerous. Ordered to take R&amp;R, he joins his buddy for beaches, beers, and babes-if that can't cure him, nothing will. But when he meets Berkeley, a woman who affects him like no one else, a new kind of battle begins . . . <br/><br/> An Admiral's daughter, Berkeley knows her life has been planned since birth. The right school, the right boyfriend-and now that she's graduated-the right marriage. But after years of being right, Berkeley is ready to be a little wrong. And Dare Conners has wrong written all over him. The sexy soldier has a body built for sin and secrets he won't share. What starts as a fling quickly grows into something more. But summer can't last forever, and when the truth comes out, both Berkeley and Dare could be in for quite a fall. <br/><br/> "<i>Last True Hero</i> is the perfect escape. Diana Gardin is a fresh new voice in contemporary romance." -- Lia Riley</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Gardin
      </h2>
      
      <p class="authorDescription body article"><B>Diana Gardin</B> is a wife of one and a mom of two. Writing is her second full time job to that, and she loves it! Diana writes contemporary romance in the Young Adult and New Adult categories. She's also a former Elementary school teacher. She loves steak, sugar cookies, and Coke, and hates working out.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18416269